// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"817084f9","731":"84e739db","787":"df4c31d2"}[chunkId] + ".chunk.js";
};